import React from 'react';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';
import Support from 'marketing/containers/support';
import {
  trackMixpanel, MP_VIEWED_MARKETING_PAGE_EVENT_NAME, MP_CLICKED_DESIGN_CONSULTATION_EVENT_NAME
} from 'common/tracking';

class Home extends React.Component {
  componentDidMount() {
    trackMixpanel(
      MP_VIEWED_MARKETING_PAGE_EVENT_NAME,
      {
        "pageName": "About us"
      }
    )
  }

  render() {
    return(<div>
    <Meta
      title="About"
      meta={[
        { name: 'robots', content: 'index,follow' },
        { name: 'description', content: "About crowdspring, the world's leading marketplace for logo design, print design, web design, graphic design and naming." },
        { name: 'keywords', content: 'crowdspring, crowdsource, contests, design contests, naming your buisness, design, crowdsourcing' }
      ]}
      link={[{ rel: 'canonical', href: getCanonicalURL('/about-us/') }]}
    />
    <section className="block">
      <div className="row">
        <div className="small-16 large-12 columns">
          <h2>We believe that&hellip;</h2>
          <h3>Creativity knows no borders.</h3>
          <p>
            We started crowdspring to address what we saw as a fundamental problem with the design                   process ... most clients had little choice and most designers had few opportunities to find              clients. Since launching in 2008, crowdspring has helped to democratize design around the                world. Over 220,000 crowdspring creatives from 195 countries have helped more than 60,000
            of the world&#8217;s best entrepreneurs, small businesses, startups, agencies, and
            non-profits with logo design, web design, graphic design, product design, and naming.
          </p>
        </div>
      </div>
    </section>
    <section className="block">
      <div className="row">
        <div className="small-16 large-12 columns">
          <h3>Design and naming can be done better</h3>
          <p>
            We want to help businesses, agencies and non-profits of any size start, run and grow their
            business through great design and naming. We&#8217;ve dramatically simplified the design
            process. We handle the complexity so that you can focus on getting great results.
          </p>
        </div>
      </div>
    </section>
    <section className="block">
      <div className="row">
        <div className="small-16 large-12 columns">
          <h3>Intellectual property should be protected</h3>
          <p>
            Businesses and creatives shouldn&#8217;t give up their legal rights simply because
            legal contracts are expensive or complex. Every project on crowdspring is protected
            by a customized legal contract - there&#8217;s never a question about ownership of IP.
	        From the day we launched, crowdspring has been the world&#8217;s leading marketplace
	        when it comes to protecting intellectual property. We&#8217;re proud of this.
          </p>
        </div>
      </div>
    </section>
    <section className="block">
      <div className="row">
        <div className="small-16 large-12 columns">
          <h3>Your success is our success</h3>
          <p>
            We&#8217;re happy only when you are and we treat our customers the way we&#8217;d want to be             treated. Our award-winning dedicated customer support team is ready around the clock, 7                  days per week, to help by phone, email, and online chat.
          </p>
        </div>
      </div>
    </section>
    <section className="block">
      <div className="row">
        <div className="small-16 large-12 columns">
          <h3>Giving back is our responsibility</h3>
          <p>
            Every few months, our community unites to help worthy non-profits and charities
            from around the world with free design projects. Design can empower and transform
            and this is one way that together, we help those in need.
          </p>
        </div>
      </div>
    </section>
    <Support
      consultationEventTracking={{
        eventName: MP_CLICKED_DESIGN_CONSULTATION_EVENT_NAME,
        eventData: {
          pageName: "About us",
          version: "english",
          pageArea: "Support footer",
        }
      }}
    />
      </div>)
  }
};


export default Home;



// WEBPACK FOOTER //
// ./marketing/about/home.jsx